import { storageData } from 'services/Services';

const VehicleLeaseFinanceList = (type) => {
    try {
        const dropdownOptions = JSON.parse(storageData.getItem(type == "leased" ? 'LeasingListGW' : 'FinanceListGW')) || [];

        const options = dropdownOptions.map((company, idx) => {
            const name = company?.providerMini?.partyInfo?.nameInfo?.commercialName || `Unknown ${idx + 1}`;
            return {
                value: name,
                label: name
            };
        });

        // Sort alphabetically by label
        options.sort((a, b) => a.label.localeCompare(b.label, undefined, { numeric: true, sensitivity: 'base' }));

        return [
            { value: "", label: "Select from list" },
            ...options
        ];
    } catch (error) {
        console.error(error)
        return [{ value: "", label: "Select from the following..." }];
    }
}

export default VehicleLeaseFinanceList